import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import Toggle from 'react-bootstrap-toggle';
import _ from 'lodash';

import moment from "moment/moment";
import 'moment-timezone';
import AssignmentFormLinks from "./AssignmentFormLinks";
import CardCheckbox from "./bootstrap/CardCheckbox";
import { spaceToUnderscore, underscoreToSpace } from "../helpers/helpers";
import {
    ASSIGNMENT__CREATE__REQUESTED,
    ASSIGNMENT__UPDATE__REQUESTED,
    ASSIGNMENT__DELETE__REQUESTED
} from "../constants/actionTypes";
import {Link} from "react-router";

const timezone = 'America/New_York';


class AssignmentForm extends Component {
    constructor(props) {
        super(props);

        this.addFilename = this.addFilename.bind(this);
        this.assignment_type_disabled = this.assignment_type_disabled.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleExit = this.handleExit.bind(this);
        this.handleAttemptsChange = this.handleAttemptsChange.bind(this);
        this.handleAssignmentUpdate = this.handleAssignmentUpdate.bind(this);
        this.handleAssignmentCreate = this.handleAssignmentCreate.bind(this);
        this.handleAssignmentCloseDateChange = this.handleAssignmentCloseDateChange.bind(this);
        this.handleAssignmentOpenDateChange = this.handleAssignmentOpenDateChange.bind(this);
        this.handleUploadCloseDateChange = this.handleUploadCloseDateChange.bind(this);
        this.handleUploadOpenDateChange = this.handleUploadOpenDateChange.bind(this);
        this.handleFilenameChange = this.handleFilenameChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.autoResizeTextarea = this.autoResizeTextarea.bind(this);

        this.handleDueDateChange = this.handleDueDateChange.bind(this);
        this.handleDateControlChange = this.handleDateControlChange.bind(this);
        this.handleScriptEnabledChange = this.handleScriptEnabledChange.bind(this);
        this.handleGroupSubmissionControlChange = this.handleGroupSubmissionControlChange.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.renderAssignmentFilenameField = this.renderAssignmentFilenameField.bind(this);
        this.removeFilename = this.removeFilename.bind(this);
        this.getMissing = this.getMissing.bind(this);
        this.getDateErrors = this.getDateErrors.bind(this);
        this.getGroupErrors = this.getGroupErrors.bind(this);
        this.getAssignmentNameErrors = this.getAssignmentNameErrors.bind(this);
        this.getFilenameErrors = this.getFilenameErrors.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);

        const { assignment, dropbox } = this.props,
            format = 'YYYY-MM-DD HH:mm:ss'
        ;

        if (this.props.type === CREATE) {
            this.state = {
                errors: {},
                assignment: {
                    name: '',
                    description: '',
                    access_enabled: false,
                    submission_enabled: false,
                    assignment_filenames: [],
                    type: '',
                    use_date_control: false,
                    use_assignment_files: false,
                    group_submission: false,
                    script_enabled: false,
                    allow_not_done: false,
                    allow_arbitrary_uploads: false,
                    allow_instructor_access_if_disabled: false,
                    submission_attempts_max: 0,
                    students_per_group_max: 0,
                    students_per_group_min: 0
                },
                dropbox: dropbox,
                selectedDateControl: 'manual',
                selectedGroupSubmissionControl: 'individual',
                showAdvanced: false
            };
        }

        if (this.props.type === EDIT) {
            const assignment_state = {
            ...assignment,
                    due_date: moment(assignment.due_date).tz(timezone).format(format),
                    submission_open_date: moment(assignment.submission_open_date).tz(timezone).format(format),
                    submission_close_date: moment(assignment.submission_close_date).tz(timezone).format(format),
                    access_open_date: moment(assignment.access_open_date).tz(timezone).format(format),
                    access_close_date: moment(assignment.access_close_date).tz(timezone).format(format),
                    students_per_group_max: assignment.students_per_group_max ? assignment.students_per_group_max : 0,
                    students_per_group_min: assignment.students_per_group_min ? assignment.students_per_group_min : 0,
                    assignment_filenames: assignment.assignment_filenames ? assignment.assignment_filenames.map(filename => ({
                        ...filename,
                        optional: filename.optional !== undefined ? filename.optional : false,
                        prevent_deletion: filename.prevent_deletion !== undefined ? filename.prevent_deletion : false,
                        description: filename.description !== undefined ? filename.description : ''
                    })) : []
            };

            this.state = {
                errors: {},
                assignment: assignment_state,
                assignment_orig: assignment_state,
                selectedDateControl: assignment.use_date_control === true ? 'date' : 'manual',
                selectedGroupSubmissionControl: assignment.group_submission === true ? 'group' : 'individual',
                requestInProgress: false,
                dropbox: dropbox,
                showAdvanced: false
            };
        }
    }

    componentDidMount() {
        // Auto-resize assignment description textarea if it has content
        const descriptionTextarea = document.getElementById('description');
        if (descriptionTextarea && descriptionTextarea.value.trim() !== '') {
            this.autoResizeTextarea(descriptionTextarea);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Auto-resize assignment description textarea when content changes
        if (prevState.assignment.description !== this.state.assignment.description) {
            const descriptionTextarea = document.getElementById('description');
            if (descriptionTextarea) {
                setTimeout(() => this.autoResizeTextarea(descriptionTextarea), 0);
            }
        }
    }

    addFilename(e) {
        e.preventDefault();

        const newFilename = {
                name : 'new_file.txt',
                optional : false,
                prevent_deletion : false,
                description : ''
            },
            { assignment } = this.state,
            { assignment_filenames } = assignment
        ;

        this.setState({
            assignment: {
                ...assignment,
                assignment_filenames: [
                    ...assignment_filenames,
                    newFilename
                ]
            }
        });
    }

    assignment_type_disabled() {
        return this.props.type === EDIT;
    }

    handleAttemptsChange (e) {
        const { value }  = e.target;

        this.setState({
            assignment: {
                ...this.state.assignment,
                submission_attempts_max:  parseInt(value)
            }
        });
    }

    handleAssignmentCreate(e) {
        e.preventDefault();

        const { assignment, dropbox } = this.state;

        if (!this.validateAssignment()){
            window.scrollTo(0, 0);
            return false;
        }

        this.props.dispatch({
            type: ASSIGNMENT__CREATE__REQUESTED,
            payload: {
                assignment: {
                    ...assignment,
                    dropbox: dropbox.id
                }
            }
        });
    }

    handleAssignmentUpdate(e) {
        e.preventDefault();

        const { assignment, dropbox } = this.state,
            dropboxName = dropbox.name,
            assignmentName = assignment.name
        ;

        if (!this.validateAssignment()) {
            window.scrollTo(0, 0);
            return false;
        }

        if (!assignment.use_assignment_files && assignment.assignment_files.length > 0) {
            if (!confirm('You have chosen to disable Course Assignment Files.  All previously uploaded Course Assignment Files will be deleted.  Do you wish to save assignment?')) {
                window.scrollTo(0, 0);
                return false;
            }
        }

        this.props.dispatch({
            type: ASSIGNMENT__UPDATE__REQUESTED,
            payload: {
                assignment: {
                    ...assignment,
                    dropbox: assignment.dropbox.id,
                },
                assignmentName,
                dropboxName,
                reload: true,
            }
        });
    }

    handleDelete(data) {
        const { assignmentId, dropboxId } = data;

        this.props.dispatch({
            type: ASSIGNMENT__DELETE__REQUESTED,
            payload: { assignmentId, dropboxId },
        });
    }

    handleExit(e) {
        const { assignment, assignment_orig } = this.state;

        if (assignment !== assignment_orig) {
            if (!confirm('All changes will be lost.  Do you wish to exit?')) {
                e.preventDefault();
            }
        }
    }

    handleAssignmentOpenDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                access_open_date: value
            }
        });
    }

    handleAssignmentCloseDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                access_close_date: value
            }
        });
    }

    handleUploadOpenDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                submission_open_date: value
            }
        });
    }

    handleUploadCloseDateChange(value) {
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
        this.setState({
            assignment: {
                ...this.state.assignment,
                submission_close_date: value
            }
        });
    }


    handleInputChange(e) {
        const { name, value }  = e.target;

        this.setState({
            assignment: {
                ...this.state.assignment,
                [name]: value
            }
        });
        
        // Auto-resize the textarea if it's the description field
        if (name === 'description' && e.target.tagName === 'TEXTAREA') {
            setTimeout(() => this.autoResizeTextarea(e.target), 0);
        }
    }

    handleCheckboxChange(e) {
        const { checked, name }  = e.target;

        this.setState({
            assignment: {
                ...this.state.assignment,
                [name]: checked
            }
        });
    }

    handleDueDateChange(value) {
        //2018-08-02 00:00:00
        value = moment(value).format('YYYY-MM-DD HH:mm:ss');

        this.setState({
            assignment: {
                ...this.state.assignment,
                due_date: value
            }
        });
    }

    handleDateControlChange(e) {
        const target = e.target;

        if (target.name === 'use_date_control') {
            const unset_fields = target.value === 'manual'
                ? {
                    submission_open_date: undefined,
                    submission_close_date: undefined,
                    access_open_date: undefined,
                    access_close_date: undefined
                } : {
                    access_enabled: false,
                    submission_enabled: false
                }
            ;

            this.setState({
                selectedDateControl: target.value,
                assignment: {
                    ...this.state.assignment,
                    use_date_control: target.value === 'date',
                    ...unset_fields
                }
            });
        }
    }

    handleGroupSubmissionControlChange(e) {
        const target = e.target;

        if (target.name === 'group_submission') {
            const unset_fields = target.value === 'group'
                ? {} : {students_per_group_max: 0, students_per_group_min: 0}
            ;

            this.setState({
                selectedGroupSubmissionControl: target.value,
                assignment: {
                    ...this.state.assignment,
                    group_submission: target.value === 'group',
                    ...unset_fields
                }
            });
        }
    }

    handleFilenameChange(e) {
        const target = e.target,
            { value, checked } = target,
            target_id = target.id.replace(/\D/g, "")
        ;

        const { assignment } = this.state,
            assignment_filenames = _.map(
                assignment.assignment_filenames,
                (item, index) => {
                    if (index !== parseInt(target_id)) {
                        return item;
                    }

                    if (target.type === "text" || target.type === "textarea") {
                        if (target.name.includes('assignment_filenames_')) {
                            return {
                                ...item,
                                name: value
                            };
                        } else if (target.name.includes('filename_description_')) {
                            return {
                                ...item,
                                description: value
                            };
                        } else {
                            return item;
                        }
                    } else if (target.name.includes('is_optional')) {
                        return {
                            ...item,
                            optional: checked
                        };
                    } else if (target.name.includes('prevent_deletion')) {
                        return {
                            ...item,
                            prevent_deletion: checked
                        };
                    } else {
                        return item;
                    }
                }
            )
        ;

        this.setState({
            assignment: {
                ...assignment,
                assignment_filenames
            }
        });
        
        // Auto-resize the textarea if it's a description field
        if (target.name.includes('filename_description_')) {
            setTimeout(() => this.autoResizeTextarea(target), 0);
        }
    }
    
    autoResizeTextarea(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = Math.max(textarea.scrollHeight, 40) + 'px';
    }

    handleScriptEnabledChange(e) {
        const { checked }  = e.target,
            { assignment } = this.state,
            { submission_attempts_max } = assignment
        ;

        this.setState({
            assignment: {
                ...this.state.assignment,
                script_enabled: checked,
                submission_attempts_max: checked ? submission_attempts_max : 0
            }
        });
    }

    onToggle(name, value) {
        this.setState({
            assignment: {
                ...this.state.assignment,
                [name]: value
            }
        });
    }

    toggleAdvanced() {
        this.setState({
            showAdvanced: !this.state.showAdvanced
        }, () => {
            // Auto-resize all textareas when advanced section is shown
            if (this.state.showAdvanced) {
                setTimeout(() => {
                    const textareas = document.querySelectorAll('textarea[name*="filename_description_"]');
                    textareas.forEach(textarea => this.autoResizeTextarea(textarea));
                }, 0);
            }
        });
    }

    removeFilename(e) {
        const target = e.target,
            target_id = parseInt(target.id.replace(/\D/g, "")),
            { assignment } = this.state,
            { assignment_filenames } = assignment
        ;

        this.setState({
            assignment:{
                ...assignment,
                assignment_filenames: _.filter(
                    assignment_filenames,
                    (x, i) => {
                        return i !== target_id;
                    }
                ),
            }
        });
    }

    validateAssignment() {
        const errors = _.union(
            this.getMissing(),
            this.getGroupErrors(),
            this.getDateErrors(),
            this.getAssignmentNameErrors(),
            this.getFilenameErrors(),
        );

        this.setState({ errors });

        return errors.length < 1;
    }

    getAssignmentNameErrors() {
        const { assignment, assignment_orig, dropbox } = this.state,
            valid_assignment_name = assignment.name.match(/^([A-Za-z0-9\-_ .]){1,255}$/),
            { assignments } = this.props,
            assignment_name_match = _.filter(
                assignments,
                a => {
                    return (
                        assignment.name.replace('_', ' ') === a.name &&
                        dropbox.id === a.dropbox.id &&
                        assignment.name !== assignment_orig.name
                    );
                }
            ).length > 0
        ;

        let assignment_name_errors = [];

        if (assignment_name_match) {

            assignment_name_errors.push(
                `Assignment:  "${assignment.name.replace('_', ' ')}" name/dropbox value has already been used.`
            );

            if (assignment.name.match(/_/)) {
                assignment_name_errors.push(
                    'Note: underscore characters "_" are automatically converted to space characters " " for Assignment Name.'
                );
            }
        }

        if (assignment.name.replace(/\s/g, "") !== '' && !valid_assignment_name) {
            assignment_name_errors.push(
                `Invalid Assignment Name: "${assignment.name}" 
                Assignment names are restricted to alphanumeric characters - upper
                and lower case letters and 0-9 digits - plus the period, underscore,
                and hyphen (minus or dash) characters.`
            );
        }

        return assignment_name_errors;
    }

    getFilenameErrors() {
        const { assignment } = this.state,
            { assignment_filenames } = assignment
        ;

        let filename_errors = [];

        _.map(
            assignment_filenames,
            (filename, i) => {
                const valid_filename = filename.name.match(/^([A-Za-z0-9\-_.]){1,255}$/);

                if (filename.name.replace(/\s/g, "") !== '' && !valid_filename) {
                    filename_errors.push(
                        `Invalid filename ${i+1}: "${filename.name}" 
                        Filenames are restricted to alphanumeric characters - upper and
                        lower case letters and 0-9 digits - plus the period, underscore,
                        and hyphen (minus or dash) characters.`
                    );
                }
            }
        );

        return filename_errors;
    }

    getMissing() {
        const { assignment } = this.state,
            {
                assignment_filenames, name, description,
                access_close_date, access_open_date, use_date_control,
                due_date, submission_close_date, submission_open_date
            } = assignment
        ;

        let missing = [];

        if (!name || name.replace(/\s/g, "") === '') {
            missing.push("Assignment Name is missing.");
        }

        _.map(
            assignment_filenames,
            (filename, i) => {
                if (!filename.name || filename.name.replace(/\s/g, "") === '') {
                    missing.push(`Filename ${i+1} is missing.`);
                }
            }
        );

        if (!description || description.replace(/\s/g, "") === '') {
            missing.push("Assignment Description is missing.");
        }

        if (!due_date) {
            missing.push("Due Date is missing.");
        }

        if (use_date_control) {
            if (!access_open_date) {
                missing.push("Assignment Accessible Open Date is missing.");
            }
            if (!access_close_date) {
                missing.push("Assignment Accessible Close Date is missing.");
            }
            if (!submission_close_date) {
                missing.push("File Upload Close Date is missing.");
            }
            if (!submission_open_date) {
                missing.push("File Upload Open Date is missing.");
            }
        }

        return missing;
    }

    getGroupErrors() {
        const { assignment } = this.state,
            { group_submission, students_per_group_min, students_per_group_max } = assignment
        ;

        if (!group_submission) {
            return [];
        }

        let group_errors = [];

        if (parseInt(students_per_group_min) < 1) {
            group_errors.push("Group minimum students per group must be greater than 0.");
        }
        if (parseInt(students_per_group_max) < 1) {
            group_errors.push("Group maximum students per group must be greater than 0.");
        }

        if (parseInt(students_per_group_max) < parseInt(students_per_group_min)) {
            group_errors.push("Group maximum students per group must be greater or equal to minimum students.");
        }

        return group_errors;
    }

    getDateErrors() {
        const { assignment } = this.state,
            {
                access_close_date, access_open_date,
                submission_close_date, submission_open_date,
                use_date_control
            } = assignment
        ;

        let date_errors = [];

        if (use_date_control) {
            if (moment(access_open_date).isAfter(moment(submission_open_date))) {
                date_errors.push("Assignment Accessible Open Date must be same or before File Uploads Open Date.");
            }

            if (moment(submission_open_date).isSameOrAfter(moment(submission_close_date))) {
                date_errors.push("File Uploads Close Date must be after File Uploads Open Date.");
            }

            if (moment(access_open_date).isSameOrAfter(moment(access_close_date))) {
                date_errors.push("Assignment Accessible Close Date must be after Assignment Accessible Open Date.");
            }

            if (moment(submission_close_date).isAfter(moment(access_close_date))) {
                date_errors.push("File Uploads Close Date must be same or before Assignment Accessible Close Date.");
            }
        }

        return date_errors;
    }

    renderAssignmentFilenameField(filename, index) {
        return (
            <span key={index}>
                <span className="input-group">
                    <input
                        name={`assignment_filenames_${index}`}
                        id={`assignment_filenames_${index}`}
                        type="text"
                        required="required"
                        className="form-control"
                        onChange={this.handleFilenameChange}
                        value={filename.name}
                    />
                    <div
                        id={`remove_assignment_filenames_${index}`}
                        onClick={this.removeFilename}
                        className="remove-filename input-group-addon"
                    >
                        <i
                            id={`remove_assignment_filenames_${index}`}
                            className="fa fa-times"
                        />
                    </div>
                </span>
                <CardCheckbox
                    className="is-optional"
                    side="right"
                    name={`is_optional_${index}`}
                    id={`is_optional_${index}`}
                    onChange={this.handleFilenameChange}
                    checked={filename.optional === true}
                >
                    Is Optional
                </CardCheckbox>
                {this.state.showAdvanced && (
                    <div>
                        <CardCheckbox
                            className="prevent-deletion"
                            side="right"
                            name={`prevent_deletion_${index}`}
                            id={`prevent_deletion_${index}`}
                            onChange={this.handleFilenameChange}
                            checked={filename.prevent_deletion === true}
                            style={{borderTop: 'none'}}
                        >
                            Prevent Deletion
                            <label className="help-text" style={{ marginLeft: '5px', display: 'inline-block'}}>
                                (If checked = undeletable)
                            </label>
                        </CardCheckbox>
                    </div>
                )}
                {this.state.showAdvanced && (
                    <textarea
                        name={`filename_description_${index}`}
                        id={`filename_description_${index}`}
                        className="form-control"
                        placeholder="Description (optional)"
                        onChange={this.handleFilenameChange}
                        value={filename.description || ''}
                        rows="2"
                        style={{fontSize: '12px', resize: 'vertical', borderTop: 'none'}}
                    />
                )}
            </span>
        );
    }

    render() {
        if (!this.state || !this.state.assignment || this.state.assignment.name === undefined) {
            return null;
        }

        const { assignment, dropbox, errors, selectedDateControl, selectedGroupSubmissionControl } = this.state,
            assignment_type_disabled = this.assignment_type_disabled()
        ;

        return dropbox
        ? (
            <form
                onSubmit={(e) => {e.preventDefault();}}
                className="border-top-0"
            >
                <div className={"action-links"}>
                    <AssignmentFormLinks
                        assignment={assignment}
                        dropbox={dropbox}
                        auth={this.props.auth}
                        type={this.props.type}
                        handleSubmit={this.props.type === EDIT ? this.handleAssignmentUpdate : this.handleAssignmentCreate}
                        handleDelete={this.props.type === EDIT ? this.handleDelete : null}
                        handleExit={this.props.type === EDIT ? this.handleExit: null}
                    />
                </div>
                <h3>{dropbox.name}</h3>
                {
                    _.map(
                        errors,
                        (error, i) => {
                            return (
                                <div className="alert alert-danger alert-dismissible" role="alert" key={`error_${i}`}>
                                    {error}
                                </div>
                            );
                        }
                    )
                }
                <div className="card assignment-edit">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="card-block">
                                <div className="card">
                                    <div className="card-header bg-primary">
                                        Assignment
                                    </div>
                                    <div className="card-block-no-top-padding">
                                        <label>Assignment Name *</label>
                                        <div className="col-md-12">
                                            <input
                                                name="name"
                                                id="name"
                                                type="text"
                                                placeholder="Assignment Name"
                                                required="required"
                                                className="form-control"
                                                value={underscoreToSpace(assignment.name)}
                                                onChange={this.handleInputChange}
                                            />
                                            <label className="help-text">
                                                Assignment URL: {location.origin}/{dropbox.name}/{spaceToUnderscore(assignment.name)}
                                            </label>
                                        </div>
                                        <label>Assignment Description *</label>
                                        <div className="col-md-12">
                                        <textarea
                                            name="description"
                                            id="description"
                                            className="form-control"
                                            placeholder="Assignment Description (250 Characters max)"
                                            required
                                            value={assignment.description}
                                            onChange={this.handleInputChange}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-block-no-top-padding">
                                        <label>Due Date *</label>
                                        <div className="input-group col-md-8">
                                            <div className="input-group-addon"><i className="fa fa-calendar" /></div>
                                            <DateTime
                                                dateFormat="YYYY-MM-DD"
                                                closeOnSelect={true}
                                                timeFormat="HH:mm:ss"
                                                inputProps={{name: "due_date", readOnly: true}}
                                                value={assignment.due_date}
                                                onChange={this.handleDueDateChange}
                                                required
                                            />
                                        </div>
                                        <label>Assignment Control (Use Dates or manual)</label>
                                        <br />
                                        <div className="assignment-control row">
                                            <div className="col-md-7 text-center">
                                                <label>
                                                    <input
                                                        name="use_date_control"
                                                        type="radio"
                                                        value="date"
                                                        required="required"
                                                        onChange={this.handleDateControlChange}
                                                        checked={selectedDateControl === "date"}
                                                    /> Date
                                                </label>
                                            </div>
                                            <div className="col-md-5 text-center">
                                                <label>
                                                    <input
                                                        name="use_date_control"
                                                        value="manual"
                                                        type="radio"
                                                        required="required"
                                                        onChange={this.handleDateControlChange}
                                                        checked={selectedDateControl === "manual"}
                                                    /> Manual
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className={
                                                assignment.use_date_control
                                                    ? "date-control control-group col-md-8"
                                                    : "date-control control-group col-md-8 disabled-overlay"
                                            }>
                                                <label>Assignment Accessible Open Date</label>
                                                <br />
                                                <div className="input-group col-md-12">
                                                    <div className="input-group-addon">
                                                        <i className="fa fa-calendar" />
                                                    </div>
                                                    <DateTime
                                                        dateFormat="YYYY-MM-DD"
                                                        closeOnSelect={true}
                                                        timeFormat="HH:mm:ss"
                                                        inputProps={{
                                                            name: "assignment_open_date",
                                                            readOnly: true
                                                        }} value={assignment.access_open_date}
                                                        onChange={this.handleAssignmentOpenDateChange}
                                                        required
                                                    />
                                                </div>
                                                <label>File Uploads Open Date</label>
                                                <br />
                                                <div className="input-group col-md-12">
                                                    <div className="input-group-addon">
                                                        <i className="fa fa-calendar" />
                                                    </div>
                                                    <DateTime
                                                        dateFormat="YYYY-MM-DD"
                                                        closeOnSelect={true}
                                                        timeFormat="HH:mm:ss"
                                                        inputProps={{
                                                            name: "assignment_open_date",
                                                            readOnly: true
                                                        }}
                                                        value={assignment.submission_open_date}
                                                        onChange={this.handleUploadOpenDateChange}
                                                        required
                                                    />
                                                </div>
                                                <label>File Uploads Close Date</label>
                                                <br />
                                                <div className="input-group col-md-12">
                                                    <div className="input-group-addon">
                                                        <i className="fa fa-calendar" />
                                                    </div>
                                                    <DateTime
                                                        dateFormat="YYYY-MM-DD"
                                                        closeOnSelect={true}
                                                        timeFormat="HH:mm:ss"
                                                        inputProps={{
                                                            name: "assignment_open_date",
                                                            readOnly: true
                                                        }} value={assignment.submission_close_date}
                                                        onChange={this.handleUploadCloseDateChange}
                                                        required
                                                    />
                                                </div>
                                                <label>Assignment Accessible Close Date</label>
                                                <br />
                                                <div className="input-group col-md-12">
                                                    <div className="input-group-addon">
                                                        <i className="fa fa-calendar" />
                                                    </div>
                                                    <DateTime
                                                        dateFormat="YYYY-MM-DD"
                                                        closeOnSelect={true}
                                                        timeFormat="HH:mm:ss"
                                                        inputProps={{
                                                            name: "assignment_open_date",
                                                            readOnly: true
                                                        }}
                                                        value={assignment.access_close_date}
                                                        onChange={this.handleAssignmentCloseDateChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className={
                                                assignment.use_date_control
                                                    ? "manual-control control-group col-md-4 disabled-overlay"
                                                    : "manual-control control-group col-md-4"
                                            }>
                                                <label>Accessible to Students</label>
                                                <br />
                                                <div className="col-md-12">
                                                    <Toggle
                                                        onClick={
                                                            () => this.onToggle('access_enabled', !assignment.access_enabled)
                                                        }
                                                        name="access_enabled"
                                                        class="manual-toggles"
                                                        id="access_enabled"
                                                        on={"ON"}
                                                        off={"OFF"}
                                                        handlestyle="secondary"
                                                        offstyle="secondary"
                                                        active={assignment.access_enabled}
                                                    />
                                                </div>
                                                <br />
                                                <label>File Uploads</label>
                                                <br />
                                                <div className="col-md-12">
                                                    <Toggle
                                                        onClick={
                                                            () => this.onToggle('submission_enabled', !assignment.submission_enabled)
                                                        }
                                                        name="submission_enabled"
                                                        id="submission_enabled"
                                                        on={"ON"}
                                                        off={"OFF"}
                                                        handlestyle="secondary"
                                                        offstyle="secondary"
                                                        active={assignment.submission_enabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-block-no-top-padding">
                                        <label>Assignment Type</label>
                                        <div className="col-md-12">
                                            <label className="help-text">
                                                Once set, the assignment type cannot be changed.
                                            </label>
                                            <div className="col-md-12">
                                                <label>
                                                    <input
                                                        name="group_submission"
                                                        type="radio"
                                                        value="individual"
                                                        required="required"
                                                        onChange={this.handleGroupSubmissionControlChange}
                                                        checked={selectedGroupSubmissionControl === 'individual'}
                                                        disabled={assignment_type_disabled}
                                                    /> Individual Submission
                                                </label>
                                            </div>
                                            <div className="col-md-12">
                                                <label>
                                                    <input
                                                        name="group_submission"
                                                        type="radio"
                                                        value="group"
                                                        required="required"
                                                        onChange={this.handleGroupSubmissionControlChange}
                                                        checked={selectedGroupSubmissionControl === 'group'}
                                                        disabled={assignment_type_disabled}
                                                    /> Group Submission
                                                </label>
                                                <div className="card-block students-per-group">
                                                    <label>Students Per Group</label>
                                                    <br />

                                                    <div className="col-md-2 float-left">
                                                        <label className="help-text">Minimum&nbsp;</label>
                                                        <input
                                                            name="students_per_group_min"
                                                            className="group-input form-control"
                                                            type="number"
                                                            min="1"
                                                            value={assignment.students_per_group_min}
                                                            onChange={this.handleInputChange}
                                                            disabled={assignment.group_submission === false ? "disabled" : null}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 float-left">
                                                        <label className="help-text">Maximum</label>
                                                        <input
                                                            name="students_per_group_max"
                                                            className="group-input form-control"
                                                            type="number"
                                                            min="1"
                                                            value={assignment.students_per_group_max}
                                                            onChange={this.handleInputChange}
                                                            disabled={assignment.group_submission === false ? "disabled" : null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-block-no-top-padding">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label>Assignment Tags</label>
                                                <div className="col-md-12">
                                                    <label className="help-text">
                                                        (Not shown to Students) (140 character max)
                                                    </label>
                                                    <input
                                                        name="type"
                                                        id="type"
                                                        type="text"
                                                        placeholder="Exam, Test, Practice..."
                                                        className="form-control"
                                                        value={assignment.type}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <CardCheckbox
                                    side="right"
                                    className="submissions"
                                    name="script_enabled"
                                    id="script_enabled"
                                    onChange={this.handleScriptEnabledChange}
                                    value={assignment.script_enabled}
                                    checked={assignment.script_enabled === true}
                                >
                                    <div>Use submission script</div>
                                    <div className="attempts">
                                        <div>
                                            <label className="help-text">
                                                Number of submission attempts
                                            </label>
                                        </div>
                                        <select
                                            disabled={assignment.script_enabled === false}
                                            onChange={this.handleAttemptsChange}
                                            name="submission_attempts_max"
                                            className="form-control max-submissions"
                                            value={assignment.submission_attempts_max}
                                        >
                                            {
                                                _.map([...Array(21).keys()], (i) => {
                                                    return <option key={`attempts_${i}`} value={i}>{i === 0 ? 'Unlimited' : i}</option>;
                                                })
                                            }
                                        </select>
                                    </div>
                                </CardCheckbox>
                                <CardCheckbox
                                    className="instructor-access"
                                    side="right"
                                    name="allow_instructor_access_if_disabled"
                                    id="allow_instructor_access_if_disabled"
                                    onChange={this.handleCheckboxChange}
                                    value={assignment.allow_instructor_access_if_disabled}
                                    checked={assignment.allow_instructor_access_if_disabled === true}
                                >
                                    Allow instructors access to the assignment if it is disabled
                                </CardCheckbox>
                                <CardCheckbox
                                    className="not-done"
                                    side="right"
                                    name="allow_not_done"
                                    id="allow_not_done"
                                    onChange={this.handleCheckboxChange}
                                    value={assignment.allow_not_done}
                                    checked={assignment.allow_not_done === true}
                                >
                                    Allow students to indicate they are not done with the assignment
                                </CardCheckbox>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="card-block filenames">
                                <div className="card">
                                    <div className="card-header bg-primary" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <span>Filenames</span>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-link text-white"
                                            onClick={this.toggleAdvanced}
                                            style={{padding: '0', fontSize: '12px'}}
                                        >
                                            <i className={`fa fa-cog`} style={{marginRight: '4px'}}/>
                                            {this.state.showAdvanced ? 'Hide Advanced' : 'Advanced'}
                                        </button>
                                    </div>
                                    <div className="card-block">
                                        <div className="filenames-container">
                                            {
                                                _.map(
                                                    assignment.assignment_filenames,
                                                    (filename, i) => {
                                                        return this.renderAssignmentFilenameField(filename, i);
                                                    }
                                                )
                                            }
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                onClick={this.addFilename}
                                                className="btn btn-success btn-md"
                                            >
                                                <span>
                                                    <i className="fa fa-plus-circle"/> Add filename
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <CardCheckbox
                                    side="right"
                                    className="arbitrary-files"
                                    name="allow_arbitrary_uploads"
                                    id="arbitrary_file"
                                    type="checkbox"
                                    onChange={this.handleCheckboxChange}
                                    checked={assignment.allow_arbitrary_uploads === true}
                                    value={assignment.allow_arbitrary_uploads}
                                >
                                    Allow file uploads without filename restrictions
                                </CardCheckbox>
                            </div>
                            <div className="card-block assignment-files">
                                <div className="card">
                                    <div className="card-header bg-primary">
                                        Course Assignment Files
                                    </div>
                                </div>
                                <CardCheckbox
                                    side="right"
                                    className="use-assignment-files"
                                    name="use_assignment_files"
                                    id="use_assignment_files"
                                    type="checkbox"
                                    onChange={this.handleCheckboxChange}
                                    checked={assignment.use_assignment_files === true}
                                    value={assignment.use_assignment_files}
                                >
                                    Allow instructors to upload assignment files which can be downloaded by students
                                </CardCheckbox>
                                {
                                    this.state.assignment_orig && this.state.assignment_orig.use_assignment_files
                                    ?
                                        <div className="manage-assignment-files">
                                            <div className="card-block">
                                                <ul>
                                                    {
                                                        _.map(
                                                            this.state.assignment_orig.assignment_files,
                                                            (item, index) => {
                                                                return (
                                                                    <li className="assignment-file" key={`assignment_${index}`}>
                                                                        <label className="help-text">
                                                                            <span className="fa fa-file-o"/> {item.name}
                                                                        </label>
                                                                    </li>
                                                                );
                                                            }
                                                        )
                                                    }
                                                </ul>
                                                <Link
                                                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/upload`}
                                                    onlyActiveOnIndex={false}
                                                >
                                                    <button
                                                        className="btn btn-success btn-md"
                                                        onClick={this.handleExit}
                                                    >
                                                        <i className="fa fa-edit"/> Manage Files
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </form>
        ) : null;
    }
}

AssignmentForm.propTypes = {
    assignment: PropTypes.object.isRequired,
    assignments: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    dropbox: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    uploadAllowed: PropTypes.bool
};

function mapStateToProps(state) {
    const { assignment, assignments, auth, request } = state;

    return { assignment, assignments, auth, request };
}

export const CREATE = 'create';
export const EDIT = 'edit';

export default connect(mapStateToProps)(AssignmentForm);



/** WEBPACK FOOTER **
 ** ./src/components/AssignmentForm.js
 **/